import {
  DEFAULT_ROUTE_PARAMS,
  ROUTES,
} from 'b2b-apps/shop/routes/components/Router/routes';
import { Router as RouterComponent } from './Router';
import { withContainer } from './withContainer';

const Router = withContainer(RouterComponent);

export {
  DEFAULT_ROUTE_PARAMS,
  Router,
  RouterComponent,
  ROUTES,
};
export * from './withContainer';
